document.addEventListener('DOMContentLoaded', function () {
    
    setTimeout(() => {
        const selectedSwatch = document.querySelector('.product-info .product-info__variant-picker .variant-picker__option input[type="radio"]:checked');
       
        if (selectedSwatch) {
            updateImage(selectedSwatch); 
        }
    }, 100); 

    
    document.addEventListener('change', function (event) {
        if (event.target.matches(' .product-info__variant-picker  .variant-picker__option input[type="radio"]')) {
            updateImage(event.target); 
        }
    });

   
    function updateImage(target) {
        const newSrc = target.getAttribute('data-image');
        const newSrcset = target.getAttribute('data-image-srcset');
        const mainImage = document.querySelector('.product-gallery__media img');
        if (mainImage && newSrc) {
            mainImage.setAttribute('src', newSrc);
            mainImage.setAttribute('srcset', newSrcset);
            //mainImage.removeAttribute('srcset');
        }
    }
});
